/*@flow*/
import isFunction from 'lib/t/isFunction';
import validate from 'lib/t/validate';

export default function getTypeInfo(
  type: any
): {|
  getValidationErrorMessage: (
    value: any,
    path: Array<any>,
    context: { ... }
  ) => any | void,
  innerType: any,
  isMaybe: boolean,
  isSubtype: boolean,
  type: any,
|} {
  let innerType = type;
  let isMaybe = false;
  let isSubtype = false;
  let kind;
  let innerGetValidationErrorMessage;

  while (innerType) {
    kind = innerType.meta.kind;
    const func = innerType.getValidationErrorMessage;
    if (func && isFunction(func)) {
      innerGetValidationErrorMessage = innerType.getValidationErrorMessage;
    }
    if (kind === 'maybe') {
      isMaybe = true;
      innerType = innerType.meta.type;
    } else if (kind === 'subtype') {
      isSubtype = true;
      innerType = innerType.meta.type;
    } else {
      break;
    }
  }

  const res = {
    type,
    isMaybe,
    isSubtype,
    innerType,
    getValidationErrorMessage: (
      _value: any,
      _path: Array<any>,
      _context: { ... }
    ) => '',
  };

  if (innerGetValidationErrorMessage) {
    res.getValidationErrorMessage = (value: any, path: any[], context: {}) => {
      const result = validate(value, type, { path, context });
      if (!result.isValid()) {
        result.errors.forEach((err) => {
          if (isFunction(err.expected.getValidationErrorMessage)) {
            return err.message;
          }
        });
        if (innerGetValidationErrorMessage) {
          return innerGetValidationErrorMessage(value, path, context);
        }
      }
    };
  }

  return res;
}
